// TODO(jon): This is a temporary file that will no longer be needed once the
// ability to have multiple boards is completed.

import useLifecycleBoard from './useLifecycleBoard';
import useLifecycleBoards from './useLifecycleBoards';

const useDefaultBoard = (swrOptions) => {
  const { data } = useLifecycleBoards();
  const boardId = data?.[0]?.boardId;
  return useLifecycleBoard(boardId, swrOptions);
};

export default useDefaultBoard;
